export const TRUCK_TYPE_VAN = "VAN";
export const TRUCK_TYPE_CUBE_12_FOOT = "CUBE_TRUCK12_FOOT";
export const TRUCK_TYPE_CUBE_14_FOOT = "CUBE_TRUCK14_FOOT";
export const TRUCK_TYPE_CUBE_16_FOOT_AND_MORE = "CUBE_TRUCK16_FOOT_AND_MORE";
export const TRUCK_TYPE_OTHER = "OTHER";
